import Marquee from "react-fast-marquee";

const WORDS = ["Keynote Design", "Web Design", "Cinematic Motion", "Brand Websites", "Investor Decks", "Creative Strategy"];

export default function EditorialMarquee() {
  return (
    <section className="py-16 md:py-24 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <Marquee speed={55} gradient={false}>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={`${w}-${i}`} className="flex items-center">
            <span className="font-display font-extrabold text-6xl md:text-8xl lg:text-[9rem] tracking-tighter text-white/90 mx-8">
              {w}
            </span>
            <span className="font-serif-accent italic text-5xl md:text-7xl text-white/25 mx-8">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
